import React from 'react'
import classnames from 'classnames'
import { Box } from '@chakra-ui/react'

import './styles.less'

const Footer = ({ children, style, padder, multi, fixed, className }) => {
  const getClassNames = classnames('footer', className, {
    padder,
    multi,
    fixed,
  })
  return (
    <Box className={getClassNames} style={style}>
      {children}
    </Box>
  )
}

Footer.defaultProps = {
  padder: false,
  fixed: false,
  multi: false,
}

export default Footer
